<div style="display: flex; flex-direction: row">
  <div style="margin-right: 50px">
    @if (!hideLayerSelector) {
      <ion-fab [activated]="openLayerSelector" #layerFab>
        <div>
          <ion-fab-button
            (dblclick)="stopPropagation($event)"
            mode="md"
            data-test="layer-selector-menu"
            size="small"
            [ngClass]="menuButtonClass"
            >
            <ion-icon name="menu-outline"></ion-icon>
          </ion-fab-button>
          @if (styleName === 'andermatt') {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="40"
              width="40"
              viewbox="0 0 100 100"
              class="sis-menu-circle-andermatt"
              >
              <circle cx="50%" cy="50%" r="42%" fill-opacity="0" stroke="#000" stroke-width="1.5" />
            </svg>
          }
        </div>
        <ion-fab-list
          side="bottom"
          (click)="stopPropagation($event)"
          (dblclick)="stopPropagation($event)"
          style="margin-top: 43px"
          >
          @for (layerSelector of layerSelectors; track layerSelector) {
            <ion-fab-button
          [ngClass]="
            layerSelector.showLayers
              ? layerSelectorActiveClass + ' ' + fabButtonClass
              : layerSelectorInactiveClass + ' ' + fabButtonClass
          "
              mode="md"
              [attr.data-test]="'sis-layer-selector-item-' + layerSelector.category.name"
              >
              <sis-layer-selector-item
                [layerSelector]="layerSelector"
                (clicked)="onClick(layerSelector)"
                [active]="layerSelector.showLayers"
              ></sis-layer-selector-item>
            </ion-fab-button>
          }
        </ion-fab-list>
      </ion-fab>
    }
  </div>

  <div>
    @if (!hideSeasonFilter && (oppositeMapExist || season === 0)) {
      <ion-grid class="sis-season-filter-grid">
        <ion-row>
          @if (!hideSeasonFilter && (oppositeMapExist || season === 0)) {
            <ion-col class="sis-season-selector-col">
              <ion-fab-button
                (click)="selectSeason(1)"
            [ngClass]="
              activeSeason !== 1
                ? layerSelectorInactiveClass + ' ' + fabButtonClass
                : layerSelectorActiveClass + ' ' + fabButtonClass
            "
                matTooltip="{{ 'general.term.summer' | translate }}"
                >
                @if (styleName === 'sisag') {
                  <ion-icon name="sunny-outline"></ion-icon>
                }
                @if (styleName === 'andermatt') {
                  <ion-img
                    [src]="summerIconSvgUrl$ | async"
                    class="sis-season-icon-andermatt"
                  ></ion-img>
                }
              </ion-fab-button>
            </ion-col>
          }
          @if (!hideSeasonFilter && (oppositeMapExist || season === 0)) {
            <ion-col class="sis-season-selector-col">
              <ion-fab-button
                (click)="selectSeason(2)"
            [ngClass]="
              activeSeason !== 2
                ? layerSelectorInactiveClass + ' ' + fabButtonClass
                : layerSelectorActiveClass + ' ' + fabButtonClass
            "
                matTooltip="{{ 'general.term.winter' | translate }}"
                >
                @if (styleName === 'sisag') {
                  <ion-icon name="snow-outline"></ion-icon>
                }
                @if (styleName === 'andermatt') {
                  <ion-img
                    [src]="winterIconSvgUrl$ | async"
                    class="sis-season-icon-andermatt"
                  ></ion-img>
                }
              </ion-fab-button>
            </ion-col>
          }
        </ion-row>
      </ion-grid>
    }
  </div>

  <div>
    @if (!hideSignPosts && hasSignPosts) {
      <ion-fab>
        <div>
          <ion-fab-button
            (dblclick)="stopPropagation($event)"
            mode="md"
            data-test="sign-post-menu"
            size="small"
            [ngClass]="menuButtonClass"
            matTooltip="{{ 'map.term.furtherMaps' | translate }}"
            >
            <ion-img
              [src]="signPostImageUrl$ | async"
              [ngStyle]="{ 'margin-left': styleName === 'andermatt' ? '1px' : '0px' }"
            ></ion-img>
          </ion-fab-button>
          @if (styleName === 'andermatt') {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="40"
              width="40"
              viewbox="0 0 100 100"
              class="sis-menu-circle-andermatt"
              >
              <circle cx="50%" cy="50%" r="42%" fill-opacity="0" stroke="#000" stroke-width="1.5" />
            </svg>
          }
        </div>
        <ion-fab-list
          side="bottom"
          (click)="stopPropagation($event)"
          (dblclick)="stopPropagation($event)"
          style="margin-top: 43px; margin-left: 8px"
          >
          @for (signPost of signPosts; track signPost) {
            <ion-fab-button
              [ngClass]="signPostOptionClass"
              mode="md"
              (click)="signPostClicked(signPost)"
              [style.width]="signPostButtonWidth"
              >
              <div style="width: 100%; text-align: start; padding-left: 12px">{{ signPost.name }}</div>
            </ion-fab-button>
          }
        </ion-fab-list>
      </ion-fab>
    }
  </div>
</div>
